// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1N4Ar","info":"UpdateTermsInfo_info__3LbGL"};